module.exports = __webpack_public_path__ + "img/w44b.8006f586.jpg";